import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import React from 'react';


import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const MessageDialog = ({ 
  open, 
  onClose, 
  title = "Notification",
  message = "",
  type = "success"
}) => {
  const isSuccess = type === "success";
  
  const getIcon = () => {
    return isSuccess ? <CheckCircleOutlineIcon fontSize="large" /> : <ErrorOutlineIcon fontSize="large" />;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          borderRadius: '12px',
          padding: '8px',
          maxWidth: '400px',
          width: '100%'
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center', pb: 0 }}>
        <LocalHospitalIcon 
          sx={{ mr: 1, color: isSuccess ? '#4caf50' : '#f44336' }} 
        />
        <Typography variant="h6" component="div">
          {title}
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 2, mb: 2 }}>
        <Alert
          severity={isSuccess ? "success" : "error"}
          icon={getIcon()}
          sx={{
            backgroundColor: isSuccess ? '#e8f5e9' : '#ffebee',
            color: isSuccess ? '#2e7d32' : '#d32f2f',
            border: `1px solid ${isSuccess ? '#c8e6c9' : '#ffcdd2'}`,
            borderRadius: '8px',
            '& .MuiAlert-icon': {
              color: isSuccess ? '#2e7d32' : '#d32f2f',
              alignItems: 'center',
              display: 'flex'
            }
          }}
        >
          <AlertTitle sx={{ fontWeight: 600 }}>
            {isSuccess ? 'Success' : 'Error'}
          </AlertTitle>
          <Typography id="alert-dialog-description" variant="body2">
            {message}
          </Typography>
        </Alert>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button 
          type="button"
          variant="contained"
          disableElevation
          size="medium"
          onClick={onClose}
          tabIndex={1}
          sx={{ 
            borderRadius: '24px',
            padding: '6px 16px',
            fontWeight: 500,
            boxShadow: 'none',
            backgroundColor: isSuccess ? '#4caf50' : '#f44336',
            '&:hover': {
              backgroundColor: isSuccess ? '#388e3c' : '#d32f2f',
            }
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;